import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter, mapResponseToVisibilityFilter, mapVisibilityFilterToInstruction } from "components/filters/mappingUtils";
import { routes } from "utilities/routing/generatedRoutes";

export const mapFilterValuesToInstruction = (
  mainArea: server.dto.MainAreas,
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedWordTemplateInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    visible: mapVisibilityFilterToInstruction(filter.visible),
    page,
    perPage,
    cache: filterSet,
    mainArea
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListWordTemplateFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  visible: mapResponseToVisibilityFilter(response.visible)
});


type WordTemplateMapping = {
  detail: (id: number) => string;
  new: () => string;
  filterSet: server.dto.FilterSets;
}

export const getMainAreaMapping = (mainArea: server.dto.MainAreas): WordTemplateMapping => {
  switch (mainArea) {
    case "show": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Show_List",
    };
    case "company": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Company_List",
    };
    case "contact": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Contact_List",
    };
    case "invoice": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Invoice_List",
    };
    case "contract": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Contract_List",
    };
    case "purchaseAgreement": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_PurchaseAgreement_List",
    };
    case "quote": return {
      detail: (id: number) => routes.wordTemplate_Detail(id).absolute,
      new: () => routes.wordTemplate_New(mainArea).absolute,
      filterSet: "wordTemplate_Quote_List",
    };
  }
}